import { pxToRem } from '../../../../utils';
var sizeToPxValue = {
  smallest: 24,
  smaller: 24,
  small: 24,
  medium: 32,
  large: 36,
  larger: 42,
  largest: 48
};
var avatarStyles = {
  root: function root(_ref) {
    var size = _ref.props.size;
    var sizeInRem = pxToRem(sizeToPxValue[size]);
    return {
      position: 'relative',
      backgroundColor: 'inherit',
      display: 'inline-block',
      verticalAlign: 'middle',
      height: sizeInRem,
      width: sizeInRem
    };
  },
  image: function image(_ref2) {
    var v = _ref2.variables;
    return {
      borderColor: v.avatarBorderColor,
      borderStyle: 'solid',
      borderWidth: v.avatarBorderWidth,
      height: '100%',
      objectFit: 'cover',
      verticalAlign: 'top',
      width: '100%'
    };
  },
  label: function label(_ref3) {
    var size = _ref3.props.size;
    var sizeInRem = pxToRem(sizeToPxValue[size]);
    return {
      display: 'inline-block',
      width: sizeInRem,
      height: sizeInRem,
      lineHeight: sizeInRem,
      fontSize: pxToRem(sizeToPxValue[size] / 2.333),
      verticalAlign: 'top',
      textAlign: 'center',
      padding: '0px'
    };
  },
  status: function status(_ref4) {
    var v = _ref4.variables;
    return {
      position: 'absolute',
      bottom: 0,
      right: 0,
      boxShadow: "0 0 0 ".concat(v.statusBorderWidth, " ").concat(v.statusBorderColor)
    };
  }
};
export default avatarStyles;